import React, { useState } from "react";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { PlanWrapper } from "../../Plan/CreatePlan/style/plan";
import Switch from "react-switch";
import { PLAN_TYPES, planType } from "../../../config/constant";
import { APIError } from "../../../core/utils";

const CreateSponsershipPlan = () => {
    const [filtereddata, _filtereddata] = useState([])
    const [loading, _loading] = useState(false);
    const [checked, setChecked] = useState(false);
    const navigate = useNavigate()

    const handleSwitch = () => {
        setChecked(!checked);
    };

    const formik = useFormik({
        initialValues: {
            name: "",
            nickname: "",
            amount: "",
            active: '',
            is_popular: checked ? 1 : 0
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Credit plan name is required").min(2, "Credit plan name must be atleast 2 characters").max(50, "Credit plan name must be atmost 50 characters"),
            nickname: Yup.string().required("Nickname is required").min(2, "Nickname must be atleast 2 characters").max(50, "Nickname must be atmost 50 characters"),
            amount: Yup.number().required("Price is required").positive("Amount must be positive").min(1, "Amount must be greater than 0").max(2000, "Amount must be smaller than 2000"),
            active: Yup.string().required("Select status value"),
        }),
        validateOnChange: true,
        onSubmit: (values) => {
            if (!loading) {
                _loading(true)
                let data = {};
                data['name'] = values.name
                data['nickname'] = values.nickname
                data['amount'] = values.amount
                data['active'] = values.active
                data['type'] = planType.ONE_TIME
                data['is_popular'] = checked ? 1 : 0
                data['plan_category'] = PLAN_TYPES.SPONSOR


                API.post(APP_URLS.ADD_PLAN, data)
                    .then((res) => {
                        const resp = res.data;
                        _loading(false);
                        if (resp.success === true) {
                            toast.success(res.data.message, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            navigate('/sponsership-plans')
                        } else {
                            toast.error(resp.message, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                        }
                    })
                    .catch(function (error) {
                        _loading(false);
                        toast.error(APIError(error), {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    });
            }

        },
    });

    return (
        <>
            <PlanWrapper>
                <div className="mt-2">
                    <div className="backContainer ms-4" onClick={() => navigate("/sponsership-plans")}>
                        <span className="backButton">x</span>
                        <span className="px-3 backButton">|</span>
                        <span className="backButton">Cancel</span>
                    </div>
                </div>
                <form className="auctionMainContainer"
                    onSubmit={(e) => {
                        formik.handleSubmit(e)
                        e.preventDefault();
                    }}>
                    <div className="headerContainer d-flex justify-content-center">
                        <h1>Create Sponsership Plan</h1>
                    </div>
                    <div className="actionContainer d-flex justify-content-end">
                        <button className={(loading ? 'disabled' : '') + " btn"} type="submit" disabled={loading}>{loading ? 'Saving...' : 'Save'}</button>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="productInfo-root">
                                    <div className="container">
                                        <div className="input-section row">
                                            <div className="formInput col-md-4">
                                                <label htmlFor="name" className="fieldLabel mb-2">
                                                    Sponsership Plan Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    className="form-control"
                                                    value={formik.values.name}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.name && formik.errors.name ? <div className="error">{formik.errors.name}</div> : null}
                                            </div>
                                            <div className="formInput col-md-4">
                                                <label htmlFor="name" className="fieldLabel mb-2">
                                                    Nickname
                                                </label>
                                                <input
                                                    type="text"
                                                    id="nickname"
                                                    name="nickname"
                                                    className="form-control"
                                                    value={formik.values.nickname}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.nickname && formik.errors.nickname ? <div className="error">{formik.errors.nickname}</div> : null}
                                            </div>
                                            <div className="formInput col-md-4">
                                                <label htmlFor="active" className="fieldLabel mb-2">
                                                    Status
                                                </label>
                                                <select name="active"
                                                    id="active"
                                                    className="form-control"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.active}
                                                    onBlur={formik.handleBlur}
                                                >
                                                    <option hidden>Select</option>
                                                    <option value='1'>Active</option>
                                                    <option value='0'>Inactive</option>
                                                </select>
                                                {formik.touched.active && formik.errors.active ? <div className="error">{formik.errors.active}</div> : null}
                                            </div>


                                        </div>
                                        <div className="price-section">
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="formInput">
                                                        <label htmlFor="price" className="fieldLabel mb-2">
                                                            Price
                                                        </label>
                                                        <div className="inputTag">
                                                            <input
                                                                type="number"
                                                                id="amount"
                                                                name="amount"
                                                                step=".01"
                                                                className="form-control"
                                                                min={1}
                                                                value={formik.values.amount}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            <p>EUR</p>
                                                        </div>
                                                        {formik.touched.amount && formik.errors.amount ? <div className="error">{formik.errors.amount}</div> : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-2">
                                                <div className="formInput">
                                                    <label className="fieldLabel mb-2">Type</label>
                                                    <button onClick={(e) => e.preventDefault()}>One Time</button>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 inputSwitchgroup">
                                                <div className="formInput">
                                                    <label className="fieldLabel mb-2">Is Popular</label>
                                                    <Switch
                                                        name="is_popular"
                                                        onChange={handleSwitch}
                                                        checked={checked}
                                                        className="react-switch"
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        offColor="#D9D9D9"
                                                        onColor="#7589EC"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </PlanWrapper>
        </>
    );
};

export default CreateSponsershipPlan;
